<template>
  <div class="container">
    <!-- 快速操作指引 -->
    <div v-show="currentSection === 'register-admin' || currentSection === ''" id="register-admin">
      <h3>快速操作指引</h3>
      <div>
        <h4>1.注册管理员</h4>
        <p>手机打开蓝牙和定位，打开微信扫码机器上的二维码，新用户进入注册页面，填写注册信息注册。（扫码前如果已经注册，扫码后直接跳到下一步，选择开门账号）</p>
        <h4>2.添加设备</h4>
        <p>注册账号扫码选择开门账号，添加设备，编辑信息后添加，第一次扫码添加设备的账号就是管理员账号，管理员账号可以扫码开门和管理设备</p>
        <h4>3.授权管理</h4>
        <p>设备默认打开自动授权开门功能，所有扫码用户扫码后都能开门。如果需要关闭自动授权，可以小程序"喜视云"登录管理员账号，在设备列表，点击设备左侧点击设备按钮，在免审参数里面关闭自动授权开关。</p>
      </div>
    </div>
    
    <!-- 功能概览 -->
    <div v-show="currentSection === 'add-device' || currentSection === ''" id="add-device">
      <h3>功能概览</h3>
      <div>
        <p>1.设备默认打开自动授权开门功能，所有扫码用户扫码后都能开门。如果需要关闭自动授权，可以小程序"喜视云"登录管理员账号，在设备列表，点击设备左侧点击设备按钮，在免审参数里面关闭自动授权开关。</p>
        <el-image
          style="width: 100%; max-width: 600px; margin-top: 10px"
          :src="img1"
          alt="" />
        <p>2.审核授权，关闭自动授权后，所有用户扫码都需要管理员授权才能开门，用户扫码后进入快速审核页面，填写姓名后确认。</p>
        <el-image
          style="width: 100%; max-width: 600px; margin-top: 10px" :src="img2" alt="" />  
        <p>管理员登录"喜视云"小程序，在设备列表，点击设备左侧点击设备按钮，在员工管理里面点修改，进入修改人员信息页面点修改后会自动审核，再点击权限分配，分配权限到需要授权的设备就能开门</p>
        <div style="display: flex;">
          <el-image
            style="width: 100%; max-width: 600px; margin-top: 10px" :src="img3" alt="" />  
          <el-image
            style="width: 100%; max-width: 600px; margin-top: 10px" :src="img4" alt="" />  
        </div>
        <p>3.权限备份，打开喜视云，点击设备列表，点击设置，点击权限备份，点击从设备上备份，等待提示上传成功，机器会响两声。</p>
        <el-image
            style="width: 100%; max-width: 600px; margin-top: 10px" :src="img5" alt="" />  
        <p>4.权限恢复，打开喜视云，点击设备列表，点击设置，点击权限恢复，点击恢复权限到设备，点击确定，等待提示开门成功，机器响两声，密码恢复成功，卡号恢复成功。</p>
        <el-image
            style="width: 100%; max-width: 600px; margin-top: 10px" :src="img6" alt="" />  
        <p>点击增加卡+密码权限，提示开门成功，机器响两声，增加权限成功；点击删除卡+密码，填写卡号和密码，提示开门成功，机器响两声，删除权限成功。
        复制权限，源设备机号选择设备蓝牙号，点源设备权限下载到设备，点击确定，等待提示开门成功，机器响两声，密码恢复成功，卡号恢复成功。能将源设备数据复制到新设备,复制数据会清除掉新设备已有数据权限。
        </p>
      </div>
    </div>

    <!-- 接线图 -->
    <div v-show="currentSection === 'authorization' || currentSection === ''" id="authorization">
      <h3>接线图</h3>
      <div>
        <el-image
            style="width: 100%; max-width: 600px; margin-top: 10px" :src="img7" alt="" />  
      </div>
    </div>
    
    <!-- 门禁机使用指南 -->
    <div v-show="currentSection === 'access-control' || currentSection === ''" id="access-control">
      <h3>门禁机使用指南</h3>
      <div>
        <h4>1.进入编程模式</h4>
        <p>按 四次"ENT" 键→输入密码 "123456"→按 "ENT" 键确认（成功进入编程模式）。</p>
        <p>注：①"123456" 为默认密码。</p>
        <p>②如成功进入编程模式，蜂鸣器会短响两声，若失败蜂鸣器会长响一声。</p>
        <h4>2.功能设置（需在编程模式下）</h4>
        <p>"0" 键：修改编程密码按 "0" 键→输入新密码→按 "ENT" 键→再次输入新密码→按 "ENT" 键→按 "9" 键退出。</p>
        <p>注：①如果增加成功，蜂鸣器会短响两声，增加失败蜂鸣器会长响一声。</p>
        <p>②密码为 6 位任意数字</p>
        <h5>"1" 键：连续注册卡片</h5>
        <p>按 "1" 键→连续刷未注册的卡→按 "ENT" 键确认→按 "9" 键退出。</p>
        <p>注：①系统会为每张卡分配一个编号且默认密码为 888888，此密码只能在卡加密码模式下用来开门。</p>
        <h5>"2" 键：单张注册卡片（可连续多张注册）</h5>
        <p>按 "2" 键→刷卡→输入 4 位用户编号→按 "ENT" 键→刷下一张卡→输入 4 位用户编号→按 "ENT" 键（→连续多张注册）→按 "ENT" 键→按 "ENT" 键→按 "9" 键退出。</p>
        <p>注：①系统会为每张卡分配一个默认密码 888888，此密码只能在卡加密码模式下用来开门。</p>
        <p>②如果刷的卡已存在，蜂鸣器会长响一声，可以接着刷下一张卡，如果输入的编号已存在，蜂鸣器会长响一声，可以接着输另外的编号。</p>
        <h5>"3" 键：删除卡片</h5>
        <p>刷卡删除：按 3 0键→刷卡→刷下一张卡→(连续刷要删除的卡)→按 "ENT" 键→按 "9" 键退出。</p>
        <p>用户编号删除：按 3 1键→输入用户编号→按 "ENT" 键→输入下一个用户编号→按 "ENT" 键→(连续多张删除)→按 "ENT" 键→按 "9" 键退出。</p>
        <p>全部卡删除：按 3 2 键→输入 "9999"→按 "ENT" 键→按 "9" 键退出。</p>
        <h5>"4" 键：设置开门模式</h5>
        <p>卡或密码：按 4 0 键→按 "ENT" 键→按 "9" 键退出 (默认为出厂设置)。</p>
        <p>卡加密码：按 4 1 键→按 "ENT" 键→按 "9" 键退出。</p>
        <p>密码：按 4 2 键→按 "ENT" 键→按 "9" 键退出。</p>
        <h5>"5" 键：设置开门时间</h5>
        <p>按 "5" 键→输入开门时间→按 "ENT" 键→按 "9" 键退出。</p>
        <p>注：①开门时间格式为 "**"，如 "03" 表示开门时间为 3 秒。</p>
        <p>②设置开门时间为 99 时，开门方式为触发模式 (刷卡开门，再次刷卡门关上)。</p>
        <h5>"6" 键：设置开门密码，出厂设置开门密码为空</h5>
        <p>设置开门密码：按 "6" 键→输入新开门密码→按 "ENT" 键→再次输入新开门密码→按 "ENT" 键→按 "9" 键退出。</p>
        <p>设置空密码：按 "6" 键→按 "ENT" 键→按 "ENT" 键→按 "9" 键退出。</p>
        <p>注：①此密码可以用在卡或密码以及密码模式下开门，密码必须为 6 位。</p>
        <p>②如果设置为空密码，在卡或密码模式下屏蔽了密码开门，在密码模式下开不了门。</p>
        <h5>按 "7" 键→设置 WG 输出格式设置</h5>
        <p>WG26：按 "7" 键→"*" 键→按 "ENT" 键→按 "9" 键退出设置</p>
        <p>WG34：按 "7" 键→"0" 键→按 "ENT" 键→按 "9" 键退出</p>
        <p>清除编程密码：机器上电后 15 秒内输入 "958801" 即可清除编程密码</p>
        <p>增加指纹（带指纹的设备）（注意：指纹编号不能超过 50 个）</p>
        <p>编程模式下：按 "7" 键→输入 2 位指纹编号→按 "ENT" 键→按 3 次指纹→增加指纹成功→按 "ENT" 键→按 "9" 键退出</p>
        <p>删除指纹编程模式下：按 "8" 键→输入 2 位指纹编号→按 "ENT" 键→删除指纹成功→按 "ENT" 键→按 "9" 键退出</p>
        <h4>3.退出键</h4>
        <p>退出键为 "9" 键。</p>
        <h4>4.门铃</h4>
        <p>门铃为 "ESC" 或 △ 键</p>
        <h4>5.修改卡密码 </h4>
        <p>(必须在卡加密码模式下操作)：</p>
        <p>按 "9" 键 (红灯灭，绿灯亮)→刷卡 (一定是授权卡)→输入原始密码 (原始密码为 888888)→按 "ENT" 键→输入新密码→按 "ENT" 键→再次输入新密码→按 "ENT" 键。</p>
        <p>注：①此密码只在卡加密码模式下有效。</p>
        <p>②修改成功后蜂鸣器会短响两声并退出编程模式。</p>
        <h4>6.设备初始化</h4>
        <p>(只清除APP通过蓝牙首次添加设备的管理员和编程密码，不清除扫码家门管理员，不清除数据)</p>
        <p>通电15秒内，长按初始化按键知道听到机器响两声，初始化完成</p>
      </div>
    </div>
    
    <!-- 接线视频 -->
    <div v-show="currentSection === 'wiring-video' || currentSection === ''" id="wiring-video">
      <h3>接线视频</h3>
      <div>
        <video ref="videoPlayer" width="100%" controls>
          <source src="http://upaiyun.fondcard.net/video/ac/video_16.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
    
    <!-- 注册管理员/添加设备视频 -->
    <div v-show="currentSection === 'register-admin-video' || currentSection === ''" id="register-admin-video">
      <h3>注册管理员/添加设备视频</h3>
      <div>
        <video ref="videoPlayer" width="100%" controls>
          <source src="http://upaiyun.fondcard.net/video/ac/video_14.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
    <!-- 注册卡号视频 -->
    <div v-show="currentSection === 'register-card-video' || currentSection === ''" id="register-card-video">
      <h3>注册卡号视频</h3>
      <div>
        <video ref="videoPlayer" width="100%" controls>
          <source src="http://upaiyun.fondcard.net/video/ac/video_15.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img1: require('@/assets/image/4fcde9a1-67e7-4c56-ad4a-5023c043e62d.png'),
      img2: require('@/assets/image/517755b8-fa46-47b0-9d92-0ff403092854.png'),
      img3: require('@/assets/image/f3b780f3-0411-4a0e-9075-78974358d606.png'),
      img4: require('@/assets/image/ad1dab86-7e8d-4db3-b9cb-4c5c233f5918.png'),
      img5: require('@/assets/image/28dbcd2b-ab97-4b52-a47f-bbf62c741ca7.png'),
      img6: require('@/assets/image/d7104a3e-6032-49a5-8da9-aeb3313b044b.png'),
      img7: require('@/assets/image/14330cec-eb00-4296-99bb-48e73920f5be.png'),
      currentSection: '' // 当前显示的章节
    }
  },
  mounted() {
    // 页面加载完成后处理锚点跳转
    this.handleAnchorJump();
    
    // 监听路由变化
    this.$nextTick(() => {
      window.addEventListener('hashchange', this.handleAnchorJump);
    });
  },
  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('hashchange', this.handleAnchorJump);
  },
  watch: {
    // 监听路由变化
    '$route'(to, from) {
      if (to.hash !== from.hash) {
        this.handleAnchorJump();
      }
    }
  },
  methods: {
    // 获取路由参数的方法
    getRouteParams() {
      // 获取查询参数 (query parameters)
      const query = this.$route.query;
      
      // 获取动态路由参数 (params)
      const params = this.$route.params;
      
      // 获取哈希值 (hash)
      const hash = this.$route.hash;
      
      // 打印参数以便调试
      console.log('Query params:', query);
      console.log('Route params:', params);
      console.log('Hash:', hash);
      
      return { query, params, hash };
    },
    
    // 处理锚点跳转
    handleAnchorJump() {
        const hash = this.$route.hash;
        const anchorId = hash.replace('#', '');
        this.currentSection = anchorId; // 设置当前显示的章节
    }
  }
}
</script>

<style lang="css" scoped>
.container {
  padding: 10px;
  line-height: 36px
}
</style>